<template>
  <hr-breadcrumbs
    :items="breadcrumbItems"
    class="q-pb-md"
  />
</template>

<script>
import { mapState } from 'pinia';
import { HrBreadcrumbs } from 'src/design-system';
import { auth } from 'src/store/auth';

export default {
  name: 'FolderBreadcrumbs',

  components: { HrBreadcrumbs },

  props: {

    // Array of pages objects
    currentPath: {
      type: Array,
      required: true,
    },

    // Show client breadcrumbs element before all others
    showClient: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['go-to-folder'],

  computed: {
    ...mapState(auth, ['currentClient']),

    mainDirectoryName() {
      return this.$route.path.split('/').find((segment) => segment !== '');
    }, // mainDirectoryName()

    mainLabel() {
      return (this.mainDirectoryName === 'files')
        ? this.$t('clientFiles.breadcrumbElLabel')
        : this.$t(`${this.mainDirectoryName}.breadcrumbElLabel`);
    }, // mainLabel()

    isCurrentPageRoot() {
      return this.currentPath.length === 0;
    }, // isCurrentPageRoot()

    breadcrumbItems() {
      const lastIndex = this.currentPath.length - 1;
      return [
        ...(this.showClient ? [{ label: this.currentClient.clientName, to: { name: 'Home' } }] : []),
        {
          label: this.mainLabel,
          handler: this.isCurrentPageRoot ? null : () => this.onGoToFolder(-1),
        },
        ...this.currentPath.map((folder, index) => ({
          label: folder.folderName,
          handler: index < lastIndex ? () => this.onGoToFolder(index) : null,
        })),
      ];
    }, // breadcrumbItems()
  },

  methods: {
    onGoToFolder(level) {
      this.$emit('go-to-folder', level);
    }, // onGoToFolder()
  },

};
</script>
